module.exports = __webpack_public_path__ + "img/yhgh1.f6b0de09.png";